import React from "react";
import { Space, Radio, Divider } from "antd";
import { IRadioGroupProps } from "./interface";
import "./index.less";
import ZTypography from "../ZTypography";
import { EColors } from "../ZColors/interface";

const { Group } = Radio;

const ZRadioGroup: React.FC<IRadioGroupProps> = ({
	vertical = false,
	options = [],
	space = "small",
	disabled = false,
	isRadioLabelWidthMax = true,
	className = "",
	showAllChildren = false,
	spaceClassName = "",
	children,
	noSpaceAlign,
	...rest
}) => {
	const renderOptions = () =>
		options.map(option => (
			<React.Fragment
				key={`${option instanceof Object ? option.datatestid : option}`}
			>
				{option instanceof Object ? (
					option.visible ?? true ? (
						<>
							{option.heading && (
								<ZTypography.ZText
									className={option.headingClassName}
								>
									{option.heading}
								</ZTypography.ZText>
							)}
							<div key={`div_${option.value}`}>
								<Radio
									key={option.value.toString()}
									value={option.value}
									disabled={option.disabled}
									data-testid={option.datatestid}
									className={`text-1 ${
										isRadioLabelWidthMax ? "w-max" : ""
									} ${option.className ?? ""}`}
								>
									{option.label}
									{option.showRecommended && (
										<ZTypography.ZText
											color={EColors.GRAY}
											colorVariant={7}
											className={`text-1 ml-2 ${
												isRadioLabelWidthMax
													? "w-max"
													: ""
											}`}
										>
											(Recommended)
										</ZTypography.ZText>
									)}
								</Radio>
								{option?.children && (
									<div
										className={`${
											showAllChildren
												? ""
												: "radio-children-selected-visible"
										} radio-children`}
									>
										{option?.children}
									</div>
								)}
								{option.divider ? (
									<Divider className="my-1" />
								) : null}
							</div>
						</>
					) : (
						<React.Fragment />
					)
				) : (
					<Radio
						key={option}
						className={isRadioLabelWidthMax ? "w-max" : ""}
						value={option}
						disabled={disabled}
					>
						{option}
					</Radio>
				)}
			</React.Fragment>
		));
	const renderButtonOptions = () =>
		options.map(option =>
			option instanceof Object ? (
				<>
					<Radio.Button
						key={option.value.toString()}
						value={option.value}
						disabled={option.disabled || disabled}
						data-testid={option.datatestid}
					>
						{option.label}
					</Radio.Button>
				</>
			) : (
				<Radio.Button key={option} value={option} disabled={disabled}>
					{option}
				</Radio.Button>
			)
		);
	return (
		<>
			<Group
				disabled={disabled}
				className={`z-radio-group ${className}`}
				{...rest}
			>
				{rest.optionType === "button" ? (
					renderButtonOptions()
				) : (
					<Space
						direction={vertical ? "vertical" : "horizontal"}
						size={space}
						align={noSpaceAlign ? undefined : "start"}
						wrap
						className={`${spaceClassName} ${
							vertical ? "mb-2" : ""
						}`}
					>
						{renderOptions()}
					</Space>
				)}
				<>{children}</>
			</Group>
		</>
	);
};

export default ZRadioGroup;
